import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=8aa76caa&scoped=true"
import script from "./Terms.vue?vue&type=script&setup=true&lang=js"
export * from "./Terms.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Terms.vue?vue&type=style&index=0&id=8aa76caa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa76caa",
  null
  
)

export default component.exports